import "./Filter.scss";
import { useState } from "react";
import CustomSearch from "../../Common/CustomSearch/CustomSearch";
import CustomDropdown from "../../Common/CustomDropdown/CustomDropdown";
import CustomButton from "../../Common/CustomButton/CustomButton";

const Filter = () => {
	// @ts-ignore
	const [fileType, setFileType] = useState(null);

	const fileTypes = [
		{ name: "Contract", code: "contract" },
		{ name: "Invoice", code: "invoice" },
		{ name: "Report", code: "report" },
	];

	const processStatus = [
		{ name: "Completed", code: "completed" },
		{ name: "Pending", code: "pending" },
	];
	const [searchTerm, setSearchTerm] = useState("");

	const handleSearchChange = (value: string) => {
		setSearchTerm(value);
	};


	return (
		<div className="filter">
			<p className="filter-title">Filters</p>
			<div className="filter-container">
				<div className="filter-item">
					<div className="filter-content">
						<p className="filter-label my-0">Search</p>
						<CustomSearch
							value={searchTerm}
							onSearchChange={handleSearchChange}
							placeholder="Search File Name	"
						/>
					</div>
					<div className="filter-content">
						<p className="filter-label my-0">File Type</p>
						<CustomDropdown
							selectedOption={fileTypes[0]}
							placeholder="Select an option"
							options={fileTypes}
							onSelect={(e) => setFileType(e.value)}
						/>
					</div>
					<div className="filter-content">
						<p className="filter-label my-0">Process Status</p>
						<CustomDropdown
							selectedOption={processStatus[0]}
							placeholder="Select an option"
							options={processStatus}
							onSelect={(e) => setFileType(e.value)}
						/>
					</div>
				</div>
				<div className="filter-button">
					<CustomButton
						label="Apply filters"
						onClick={() => {}}
						iconsOnly={false}
						disabled={true}
						variant="primary"
					/>

					<CustomButton
						label="Reset filters"
						onClick={() => {}}
						iconsOnly={false}
						variant="tertiary"
						disabled={true}
					/>
				</div>
			</div>
		</div>
	);
};

export default Filter;
